import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';

interface Action {
  label: string;
  type: string;
  action: () => void;
}

@Component({
  selector: 'app-description-card',
  standalone: true,
  imports: [DesyAngularModule, CommonModule],
  templateUrl: './description-card.component.html',
  styleUrls: ['./description-card.component.scss'],
})
export class DescriptionCardComponent {
  @Input() actions: Action[] = [];
  @Input() title = '';
  @Input() subtitle = '';
  @Input() description: string = null;
  @Input() urlDetail = '';
}
